export default function filesDroppedOnNodeFactory(event) {
  function filesDroppedOnNode({ state, graphql }) {
    const selectedFiles = state.get('media.selectedFiles')
    const selectedIds = selectedFiles.map(file => {
      return `"${file}"`
    })

    if (selectedIds.length > 0) {
      const node = state.get('node.drop.id')
      if (node) {
        if (event === 'moveMedias') {
          selectedFiles.forEach(file => {
            state.unset(`media.files.${file}`)
          })
        }
        const query = `{
          ${event}(ids: [${selectedIds.join()}], node : "${node}")
        }`
        return graphql.mutate(query)
      }
    }
  }

  return filesDroppedOnNode
}



// WEBPACK FOOTER //
// ./src/modules/Media/factories/filesDroppedOnNode.js